import React, { useEffect, useState } from "react";
import { Transfer } from "antd";
import usePrivileges from "hooks/access-control/usePrivileges";

export default function AssignPrivilegesToUser({
  assignedPrivileges,
  disabled,
  onPrivilegesChange,
}) {
  const { privileges } = usePrivileges();
  const [data, setData] = useState([]);
  const [targetPrivileges, setTargetPrivileges] = useState([]); // store assigned privileges
  const [originalAssignedIds, setOriginalAssignedIds] = useState([]); // to filter out already assigned ids

  // convert privileges to required format
  useEffect(() => {
    if (!privileges || privileges.length === 0) return;

    const formatted = privileges.map((p) => ({
      key: p.id.toString(),
      title: p.name,
      description: p.description || p.name,
    }));

    setData(formatted);
  }, [privileges]);

  // pre-select user assigned privileges
  useEffect(() => {
    if (!assignedPrivileges) return;
    const selected = assignedPrivileges.map((p) => p?.privilege?.id.toString());
    setTargetPrivileges(selected);
    setOriginalAssignedIds(selected);
  }, [assignedPrivileges]);

  const filterOption = (inputValue, option) =>
    option.title.toLowerCase().includes(inputValue.toLowerCase()) ||
    option.description.toLowerCase().includes(inputValue.toLowerCase());

  const handleChange = (newTargetPrivileges) => {
    if (disabled) return;
    setTargetPrivileges(newTargetPrivileges);

    // compute privileges added and removed
    const addedPrivileges = newTargetPrivileges.filter(
      (id) => !originalAssignedIds.includes(id),
    );
    const removedPrivileges = originalAssignedIds.filter(
      (id) => !newTargetPrivileges.includes(id),
    );

    // send both added and removed to parent
    onPrivilegesChange?.({
      added: addedPrivileges,
      removed: removedPrivileges,
    });
  };

  return (
    <Transfer
      dataSource={data}
      showSearch
      filterOption={filterOption}
      targetKeys={targetPrivileges}
      onChange={handleChange}
      render={(item) => item.title}
      titles={["Available Privileges", "Assigned Privileges"]}
      disabled={disabled}
    />
  );
}
